// extracted by mini-css-extract-plugin
export default {"btnpwd":"d7b97c06a3"};